import React from 'react';
import { ChevronDown, Star } from 'lucide-react';
import { motion } from 'framer-motion';
const miniOpinions = [{
  name: 'Lic. Martina G.',
  text: 'Me cambió la dinámica del consultorio.'
}, {
  name: 'Lic. Camila R.',
  text: 'Ahorro 3 horas por semana en planes.'
}, {
  name: 'Lic. Sofía Á.',
  text: 'Los casos clínicos son oro puro.'
}, {
  name: 'Lic. Valentina P.',
  text: 'Mis pacientes mejoraron su adherencia.'
}];
const features = [{
  emoji: '📄',
  text: '100% PDF'
}, {
  emoji: '⚡',
  text: 'Acceso Inmediato'
}, {
  emoji: '📚',
  text: '5 Tomos + 5 Bonos'
}, {
  emoji: '🗂️',
  text: 'Plantillas Editables +30 funciones'
}];
export function Hero() {
  const scrollToComprar = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full bg-gradient-to-b from-emerald-50 to-white py-8 md:py-12" data-id="element-136">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-138">
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-139">
            Organizá tu consultorio y recuperá horas cada semana.
            <span className="block text-emerald-600 mt-1" data-id="element-140">
              Sin sumar estrés.
            </span>
          </h1>

          {/* Main product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="mb-5" data-id="element-141">
            <img src="https://cdn.magicpatterns.com/uploads/eXx5DJgjLSretsKxRVdpK5/ChatGPT_Image_Jun_1__2026__08_19_41_AM-removebg-preview.png" alt="Megapack NutriEficiente" className="mx-auto w-64 sm:w-80 md:w-[22rem] lg:w-[26rem] cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToComprar} data-id="element-142" />
          </motion.div>

          {/* Subtitle */}
          <h2 className="text-base sm:text-lg md:text-2xl font-bold text-slate-700 mb-5 max-w-3xl mx-auto leading-snug px-2" data-id="element-143">
            📚 Sistema de optimización para tu consultorio. Para nutricionistas
            de Argentina.
          </h2>

          {/* Feature pills */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="flex flex-wrap items-center justify-center gap-2 mb-7 max-w-3xl mx-auto" data-id="element-144">
            {features.map((feature, idx) => <div key={idx} className="inline-flex items-center gap-1.5 bg-white border-2 border-emerald-200 px-3 py-1.5 rounded-full shadow-sm" data-id="element-145">
                <span className="text-sm" data-id="element-146">{feature.emoji}</span>
                <span className="font-semibold text-slate-800 text-xs sm:text-sm" data-id="element-147">
                  {feature.text}
                </span>
              </div>)}
          </motion.div>

          {/* First CTA button */}
          <button onClick={scrollToComprar} className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-base md:text-lg px-8 md:px-10 py-4 md:py-5 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 inline-flex items-center gap-2 mb-6" data-id="element-148">
            QUIERO OPTIMIZAR MI CONSULTORIO
            <ChevronDown className="w-5 h-5" data-id="element-149" />
          </button>

          {/* Stats below CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.5
        }} className="flex items-center justify-center gap-8 sm:gap-12 mb-8" data-id="element-150">
            <div className="text-center" data-id="element-151">
              <div className="text-3xl sm:text-4xl font-bold text-emerald-600" data-id="element-152">
                5+5
              </div>
              <div className="text-xs sm:text-sm text-slate-600 font-medium" data-id="element-153">
                Tomos + Bonos
              </div>
            </div>
            <div className="h-12 w-px bg-emerald-200" data-id="element-154" />
            <div className="text-center" data-id="element-155">
              <div className="text-3xl sm:text-4xl font-bold text-emerald-600 flex items-center justify-center gap-1" data-id="element-156">
                4.9/5
                <Star className="w-6 h-6 sm:w-7 sm:h-7 fill-amber-400 text-amber-400" data-id="element-157" />
              </div>
              <div className="text-xs sm:text-sm text-slate-600 font-medium" data-id="element-158">
                Calificación
              </div>
            </div>
          </motion.div>

          {/* 4 opinions - below CTA, above problematicas */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.5
        }} className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 max-w-5xl mx-auto" data-id="element-159">
            {miniOpinions.map((opinion, idx) => <div key={idx} className="bg-white rounded-lg p-2.5 sm:p-3 shadow-sm border border-emerald-100 text-left" data-id="element-160">
                <div className="flex gap-0.5 mb-1.5" data-id="element-161">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-amber-400 text-amber-400" data-id="element-162" />)}
                </div>
                <p className="text-slate-700 text-[11px] sm:text-xs mb-1 italic leading-snug" data-id="element-163">
                  "{opinion.text}"
                </p>
                <p className="text-[10px] font-bold text-emerald-700" data-id="element-164">
                  — {opinion.name}
                </p>
              </div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}